export default __webpack_public_path__ + "static/media/salami-papryka-kukurydza.cd3e2378.png";